import React, { useState, useEffect } from "react";
import BsNavbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import { AiOutlineHome, AiOutlineUser, AiOutlineFundProjectionScreen } from "react-icons/ai";
import { FaBomb } from "react-icons/fa6";
import { CgFileDocument } from "react-icons/cg";
import { FaGithub } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";
import { IoMdContact } from "react-icons/io";
import { LiaCertificateSolid } from "react-icons/lia";
import { MdDarkMode, MdLightMode } from "react-icons/md";


import NavDropdown from "react-bootstrap/NavDropdown"; // Import NavDropdown

import '../App.css';

const SCROLL_THRESHOLD_PX = 20;

function Navbar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const [theme, setTheme] = useState(() =>
    document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'
  );

  useEffect(() => {
    function scrollHandler() {
      updateNavbar(window.scrollY >= SCROLL_THRESHOLD_PX);
    }

    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  function toggleTheme() {
    const nextTheme = theme === 'light' ? 'dark' : 'light';
    const root = document.documentElement;

    root.setAttribute('data-theme', nextTheme);
    root.setAttribute('data-bs-theme', nextTheme);

    try {
      localStorage.setItem('theme', nextTheme);
    } catch (error) {
      // The visual toggle still works when storage is blocked or unavailable.
    }

    setTheme(nextTheme);
  }

  return (
    <BsNavbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "t-dark-island sticky" : "t-dark-island"}
    >
      <Container>
        <BsNavbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img
            src={`${process.env.PUBLIC_URL}/sidelogo.png`}
            alt="Jide Oyelayo — home"
            className="nav-brand-logo"
          />
        </BsNavbar.Brand>
        <BsNavbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        />
        <BsNavbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)}>
                <AiOutlineHome className="nav-icon" /> Home
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/about" onClick={() => updateExpanded(false)}>
                <AiOutlineUser className="nav-icon" /> About
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/project" onClick={() => updateExpanded(false)}>
                <AiOutlineFundProjectionScreen className="nav-icon" /> Projects
              </Nav.Link>
            </Nav.Item>            
            <Nav.Item>
              <Nav.Link as={Link} to="/resume" onClick={() => updateExpanded(false)}>
                <CgFileDocument className="nav-icon" /> Resume
              </Nav.Link>
            </Nav.Item>            
            <Nav.Item>
              <Nav.Link as={Link} to="/leetcode" onClick={() => updateExpanded(false)}>
                <SiLeetcode className="nav-icon" /> Leetcode
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/github" onClick={() => updateExpanded(false)}>
                <FaGithub className="nav-icon" /> GitHub
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/contact" onClick={() => updateExpanded(false)}>
                <IoMdContact  className="nav-icon" /> Contact
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="theme-toggle-item">
              <button
                type="button"
                className="theme-toggle"
                onClick={toggleTheme}
                aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
                title={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
              >
                {theme === 'light' ? (
                  <MdDarkMode className="nav-icon" aria-hidden="true" />
                ) : (
                  <MdLightMode className="nav-icon" aria-hidden="true" />
                )}
                <span className="theme-toggle__label">
                  {theme === 'light' ? 'Dark' : 'Light'}
                </span>
              </button>
            </Nav.Item>
            <NavDropdown title="More" id="collasible-nav-dropdown">
            <NavDropdown.Item as={Link} to="/certificates" onClick={() => updateExpanded(false)}>
                <LiaCertificateSolid className="nav-icon" /> Certificates
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/secret" onClick={() => updateExpanded(false)}>
                <FaBomb className="nav-icon" /> Studio
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </BsNavbar.Collapse>
      </Container>
    </BsNavbar>
  );
}

export default Navbar;
